module.exports = __webpack_public_path__ + "static/gatesFoundation-7a78586f2fe61729225f8412d7d669d7.png";